import axios from 'axios';

const API = process.env.VUE_APP_BASE_URI;

export default {
    updateProfile({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            axios.put(`${API}/user/${data.id}`, data)
                .then(({
                    data
                }) => {
                    commit("SET_USER", data.data)
                    resolve(data);
                })
                .catch(error => reject(error.response))
        })
    }

}